// extracted by mini-css-extract-plugin
export default {"sound":"SoundButton_sound__SjQoY","active":"SoundButton_active__ygxPX"};